"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Responsibility of this class is to provide string values corresponding key provided
 */
class CalendarStringProvider {
    constructor(stringsSource) {
        this.stringsSource = stringsSource;
    }
    getString(key) {
        if (this.stringsSource[key]) {
            return this.stringsSource[key];
        }
        return '';
    }
}
exports.default = CalendarStringProvider;
